__turbopack_context__.v({
  "bgGrid": "Section-module-scss-module__M7iyMq__bgGrid",
});
